/*
 * FILE: unified_ui/src/main.ts
 * PURPOSE: Application entry. Mounts Vue, registers Pinia + vue-router, imports global styles.
 * OWNS: bootstrap side effects only.
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { initSentry } from './lib/sentry'
import './style.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)

initSentry(app)

app.mount('#app')
